import $ from "jquery"
import ScrollMagic from 'scrollmagic';

$(window).on('load', function() {
  if ($('#teams-trigger').length > 0 && $(window).width() > 767) {
    var controller = new ScrollMagic.Controller()
    var duration = $('.section--teams').height() - $('#slides-scroll3').height() - 100
    var offsetVal = 305

    if ($(window).width() < 1600) {
      offsetVal = 150
    }

    if ($(window).width() < 1199) {
      offsetVal = 250
    }

    if ($(window).width() < 992) {
      offsetVal = 300
    }
    var scene = new ScrollMagic.Scene({triggerElement: '#teams-trigger', offset: offsetVal, duration: duration})
      .setPin('#slides-scroll3', {pushFollowers: false})
      .addTo(controller)

    var scene1 = new ScrollMagic.Scene({triggerElement: '#build-a-team', duration: $('#build-a-team').height()})
      .addTo(controller)
      .on('enter', myFunction)

    var scene2 = new ScrollMagic.Scene({triggerElement: '#hire-individual-developers-and-other-specialists', duration: $('#hire-individual-developers-and-other-specialists').height()})
      .addTo(controller)
      .on('enter', myFunction2)

    // var scene3 = new ScrollMagic.Scene({triggerElement: '#teams-step3', duration: $('#teams-step3').height()})
    //   .addTo(controller)
    //   .on('enter', myFunction3)
  }
})

function myFunction () {
  $('.teams-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#teams-scroll_1').addClass('link-active')
  $('#build-a-team').css('opacity', 1)
}

function myFunction2 () {
  $('.teams-scroll__wrapper li').removeClass('link-active')
  $('.slide-scroll__item').css('opacity', 0.5)
  $('#teams-scroll_2').addClass('link-active')
  $('#hire-individual-developers-and-other-specialists').css('opacity', 1)
}

// function myFunction3 () {
//   $('.teams-scroll__wrapper li').removeClass('link-active')
//   $('.slide-scroll__item').css('opacity', 0.5)
//   $('#teams-scroll_3').addClass('link-active')
//   $('#teams-step3').css('opacity', 1)
// }
